import { Reducer } from 'redux';
import { Unit } from "models/Unit";
import { IUnitActions, UnitActionType } from "redux/actions/settings/UnitActions";

const initialState: Unit[] | null = null;
export const unitsReducer: Reducer<Unit[] | null, IUnitActions> =
    (state = initialState, action) => {
        switch (action.type) {
            case UnitActionType.FETCH_UNITS_SUCCESS:
                {
                    return action.returnPayload as Unit[];
                }
            case UnitActionType.ADD_UNIT_SUCCESS:
                {
                    let newUnits = [...state!];
                    newUnits.push({ ...action.returnPayload } as Unit)
                    return newUnits;
                }
            case UnitActionType.EDIT_UNIT_SUCCESS:
            case UnitActionType.DELETE_UNIT_SUCCESS:
                {
                    let newUnits = [...state!];
                    const updatedUnit = { ...action.returnPayload } as Unit;
                    newUnits = newUnits.map(nm => nm.id === updatedUnit.id ? updatedUnit : nm);
                    return newUnits;
                }
            default:
                return state;
        }
    };
